export default {
  forEmployer: 'For employer',
  language: 'Language'
}
